import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { _AdquisitionItemBudgetID } from '../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../core/services/dataBean/useDataBean';

interface Props {
    idAdquisitionItem: number;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectBudgetIDByIDAdquisitionItem = ({ idSelector, onChange, label, returnType = "ID", idAdquisitionItem }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_AdquisitionItemBudgetID);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idAdquisitionItem) {
            getLista(idAdquisitionItem);
        }
    }, [idAdquisitionItem]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDProject === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDProject,
                    label: `${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = (id: number) => {
        instance.getAdquisitionItemBudgetIDCatalog(id).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);

                }
                console.log(resp)
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? null : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDAdquisitionItemBudgetID,
        label: `${item.DataBeanProperties.BudgetIDStr ?? item.DataBeanProperties.JsonCode} - ${item.DataBeanProperties.BudgetName}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Rubro presupuestal disponible"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Rubro Presupuestal..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
